import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';
import routing from './daily_active_report.routes';
import ActivePowerService from '../../../components/api/active_power/active_power.service';
import WeatherService from '../../../components/api/weather/weather.service';
import CompareWeatherLogic from '../../../components/logic/compare_weather/compare_weather.logic';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import MathUtil from '../../../components/logic/math_util/math_util';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import PowerFormatter from '../../../components/logic/power-formatter/power-formatter.logic';
import chartConfig from './daily_active_report.config';

export class DailyActiveReportController {
  /*@ngInject*/
  constructor($stateParams, moment, $interval, $q, PowerFormatter, ActivePowerService, DateUtil, MathUtil, CsvUtil, WeatherService, CompareWeatherLogic) {
    this.ActivePowerService = ActivePowerService;
    this.WeatherService = WeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.MathUtil = MathUtil;
    this.CsvUtil = CsvUtil;
    this.interval = $interval;
    const self = this;
    this.moment = moment;
    this.$q = $q;

    this.categories = DateUtil.getXLabels; // ['00:30', '01:00', ... '00:00']
    this.id = $stateParams.id;
    this.today = new Date();
    this.targetDate = $stateParams.target || this.today;
    $stateParams.target = null;

    this.maxDate = this.today;
    this.missingTimes = [];
    this.noCalculateTimes = [];

    this.downloadFileName = 'active_power.csv';

    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.updateGraph(this.targetDate);

    this.timer = this.interval(() => {
      this.updateGraph(this.targetDate);
    }, 300000);
  }

  changeDate(diff) {
    if (diff !== undefined) {
      this.targetDate = this.DateUtil.leapDate(this.targetDate, diff);
    }

    this.updateGraph(this.targetDate);
  }

  updateGraph(targetDate) {
    const powerQuery = angular.extend({id: this.id}, this.DateUtil.getActivePowerQueries(targetDate));
    const weatherQuery = angular.extend({sa_config_id: this.id}, this.DateUtil.getQueryParams(targetDate));

    const dataPromise = this.$q.all([
      this.ActivePowerService.show(powerQuery).$promise,
      this.WeatherService.api.index(weatherQuery).$promise
    ]);
    const upperLimitPromise = dataPromise.then(responses => {
      const maxValue = Math.max.apply(Math, responses[0].powers.map(power => { return power.value; }));
      return this.ActivePowerService.upper_limit({id: this.id, ref_value: maxValue}).$promise
    });

    this.$q.all([
      dataPromise,
      upperLimitPromise
    ]).then(responses => {
      const upperLimit = responses[1].upper_limit;
      const powerData = responses[0][0];
      const weatherData = responses[0][1];
      [this.activePowers, this.missingTimes, this.noCalculateTimes] = this.PowerFormatter.formatActivePowers(powerData.powers, this.categories, this.targetDate, upperLimit);

      let weathers = [];
      if (this.chart) {
        weathers = this.setWeather(weatherData);
        this.series.setData(this.activePowers);
      }

      this.csvData = this.CsvUtil.processActivePower(this.activePowers, this.categories, targetDate, this.missingTimes, this.noCalculateTimes, weathers);
      this.downloadFileName = this.moment(this.targetDate).format('[active_power_]YYYY-MM-DD[.csv]');
    });
  }

  isMissingTime(time) {
    return this.missingTimes.indexOf(time) !== -1
  }

  isNoCalculateTime(time) {
    return this.noCalculateTimes.indexOf(time) !== -1
  }

  $onDestroy() {
    if (this.timer) {
      this.interval.cancel(this.timer);
    }
  }

  setWeather(weathers) {
    const weatherSamplingInterval = ['03:00', '09:00', '15:00', '21:00'];

    this.weathers = this.CompareWeatherLogic.compareHourly(weathers, weatherSamplingInterval);
    const y = this.weathers.length > 0 ? 46 : null;

    this.chart.xAxis[0].update({
      labels: {y: y}
    }, false);

    this.chart.reflow();

    return this.weathers;
  }
}

export default angular.module('leptonApp.dailyActiveReport', [uiRouter, moment, PowerFormatter, MathUtil, DateUtil, ActivePowerService, CsvUtil, WeatherService, CompareWeatherLogic])
  .config(routing)
  .component('dailyActiveReport', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./daily_active_report.html'),
    controller: DailyActiveReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/active_report/daily/daily_active_report.component.js